import { Row, Col, Badge } from 'react-bootstrap'
import { DefaultButton } from 'components'
import toast from 'core/toast'
import { ApplicationLogDto } from 'generated/v1/v1IntegrationsApi'
import moment from 'moment'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export interface IPageProps {
    log: ApplicationLogDto
}
const ApplicationLogsDetails = ({ log }: IPageProps) => {

    const handleCopy = async () => {
        if (!log) return

        let url = `${window.location.origin}/logs/application-logs/${log.indexName}/${log.id}`
        navigator.clipboard.writeText(url)
        toast.success('URL to application log copied to clipboard.')
    }

    const renderCommaSeparatedList = (list: string | undefined) => {
        if (!list) return null
        return list.split(',').map((item, index) => (
            <span key={index} style={{ display: 'inline-block', marginRight: '5px' }}>
                {item.trim()}
                {index < list.split(',').length - 1 && ','}
            </span>
        ))
    }

    const renderFormattedJson = (jsonString: string | undefined) => {
        if (!jsonString) return null
        try {
            const jsonObject = JSON.parse(jsonString)
            return <pre>{JSON.stringify(jsonObject, null, 2)}</pre>
        } catch (e) {
            return jsonString
        }
    }


    const getBadgeVariant = (level: string) => {
        switch (level.toLowerCase()) {
            case 'error':
                return 'danger'
            case 'warn':
                return 'warning'
            case 'info':
                return 'info'
            case 'debug':
                return 'secondary'
            default:
                return 'primary'
        }
    }

    return (
        <>
            <Row className='mb-3'>
                <Col xs={12}>
                    <div className='p-1'>
                        <DefaultButton
                            className='btn btn-sm mb-3'
                            variant='default'
                            onClick={handleCopy}
                        >
                            <span><FontAwesomeIcon icon={faCopy} /> Copy URL</span>
                        </DefaultButton>
                        <div className='mb-2'><strong className='me-2'>Level:</strong>
                            {log.level ?
                                <Badge bg={getBadgeVariant(log.level)}>{log.level}</Badge>
                                : null
                            }</div>
                        <strong>Exception Message:</strong><br /> <span className='logsHighlightColor'>{log.exceptionMessage}</span> <br /><br />

                        <Row className='mb-3'>
                            <Col md={6}>
                                <strong>Dealer ID:</strong> {log.dealerId} <br />
                                <strong>Dealer Group ID:</strong> {log.dealerGroupId} <br />
                                <strong>Dealer Name:</strong> {log.dealerName} <br />
                                <strong>Website ID:</strong> {log.websiteId} <br />
                                <strong>Integration Api ID:</strong> {log.integrationApiId} <br /><br />
                            </Col>
                            <Col md={6}>
                                <strong>X-Request-ID:</strong> {log.xRequestId} <br />
                                <strong>User ID:</strong> {log.userId} <br />
                                <strong>User Name:</strong> {log.userName} <br />
                                <strong>User Agent:</strong> {log.userAgent} <br />
                                <strong>User Device:</strong> {log.device}<br />
                            </Col>
                            <Col md={6}>
                                <strong>Application Name:</strong> {log.applicationName} <br />
                                <strong>Logger:</strong> {log.logger} <br />
                                <strong>Timestamp:</strong> {moment(log.timestamp).format('YYYY-MM-DD hh:mm:ss A')} <br />
                                <strong>Additional Info:</strong> {log.additionalInfo} <br /><br />
                            </Col>
                            <Col md={6}>
                                <strong>Status Code:</strong> {log.statusCode} <br />
                                <strong>Machine Name:</strong> {log.machineName} <br />
                                <strong>ID:</strong> {log.id} <br />
                                <strong>Index:</strong> {log.indexName} <br />
                            </Col>
                        </Row>



                        <strong>Request Method:</strong> {log.requestMethod} <br />
                        <strong>Request Url:</strong> {log.requestUrl}<br />
                        <strong>Client Origin:</strong> {log.clientOrigin}<br /><br />

                        <strong>Exception:</strong> <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}> <span className='logsHighlightColor'>{log.exception}</span></pre>

                        <strong>Session:</strong><br /> {log.session} <br /><br />

                        <strong>Products:</strong><br /> {renderCommaSeparatedList(log.products)} <br /><br />

                        <strong>Permissions:</strong><br /> {renderCommaSeparatedList(log.permissions)} <br /><br />

                        <strong>Request Body:</strong><br /> {renderFormattedJson(log.requestBody)}<br /><br />

                        <strong>Response Body:</strong><br /> {renderFormattedJson(log.responseBody)}<br /><br />

                        <strong>Raw Message:</strong><br /> <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{renderFormattedJson(log.message)}</pre>
                    </div>
                </Col>
            </Row>
        </>
    )
}
export default ApplicationLogsDetails